(function () {
  var root = document.getElementById('neuroAdvertorial');
  if (!root) return;

  function trackEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
    if (window.console && window.console.info) {
      console.info('[valma_neuroinflamacion]', name, data || {});
    }
  }

  trackEvent('advertorial_view', { page: 'neuroinflamacion' });

  // scroll depth tracking (25/50/75/100), fired once each
  var scrollMarks = { 25: false, 50: false, 75: false, 100: false };
  var ticking = false;

  function checkScrollDepth() {
    ticking = false;
    var doc = document.documentElement;
    var scrollTop = window.scrollY || doc.scrollTop;
    var scrollHeight = doc.scrollHeight - doc.clientHeight;
    if (scrollHeight <= 0) return;
    var pct = (scrollTop / scrollHeight) * 100;
    [25, 50, 75, 100].forEach(function (mark) {
      if (!scrollMarks[mark] && pct >= mark) {
        scrollMarks[mark] = true;
        trackEvent('advertorial_scroll_' + mark, { page: 'neuroinflamacion' });
      }
    });
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(checkScrollDepth);
      ticking = true;
    }
  }, { passive: true });

  // offer section view
  var offerSection = document.getElementById('oferta');
  if (offerSection && 'IntersectionObserver' in window) {
    var offerObserved = false;
    var offerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !offerObserved) {
          offerObserved = true;
          trackEvent('neuro_offer_view', {});
          offerObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    offerObserver.observe(offerSection);
  }

  // product CTA clicks (hero, offer, final CTA)
  root.querySelectorAll('.neuro-cta-product').forEach(function (btn) {
    btn.addEventListener('click', function () {
      trackEvent('neuro_product_click', { label: btn.textContent.trim() });
    });
  });

  // in-page anchor CTAs (mid-content offer box, etc.)
  root.querySelectorAll('.neuro-cta-anchor').forEach(function (btn) {
    btn.addEventListener('click', function () {
      trackEvent('neuro_cta_click', { label: btn.dataset.label || btn.textContent.trim() });
    });
  });

  // sticky mobile CTA — reveal after ~22% scroll, hide near the offer section
  var stickyCta = document.getElementById('neuroStickyCta');
  var stickyCtaBtn = document.getElementById('neuroStickyCtaBtn');
  if (stickyCta) {
    var stickyShown = false;
    function checkSticky() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var scrollHeight = doc.scrollHeight - doc.clientHeight;
      if (scrollHeight <= 0) return;
      var pct = (scrollTop / scrollHeight) * 100;
      var shouldShow = pct >= 22 && pct < 96;
      stickyCta.classList.toggle('is-visible', shouldShow);
      if (shouldShow && !stickyShown) {
        stickyShown = true;
      }
    }
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(checkSticky);
    }, { passive: true });
    checkSticky();
  }
  if (stickyCtaBtn) {
    stickyCtaBtn.addEventListener('click', function () {
      trackEvent('neuro_cta_click', { label: 'sticky_ver_valma_nuva' });
    });
  }
})();
